import { IUnSdg } from 'src/types';

import { List, ListImage } from './product-image.styled';

interface IProps {
  unSdg: IUnSdg[];
  withIndicator?: boolean;
}

export const UnSdgList = ({ unSdg, withIndicator }: IProps) => {
  return (
    <List id="un-sdg-list-component__components-product-image__list__l12" withIndicator={withIndicator}>
      {unSdg.map((item) =>
      <li id="un-sdg-list-component__components-product-image__li__l14" key={item.id}>
          <ListImage id="un-sdg-list-component__components-product-image__listimage__l15" src={item.image_medium || item.image} alt={item.name} />
        </li>
      )}
    </List>);

};